import { render, staticRenderFns } from "./duothemedialog.vue?vue&type=template&id=78b012b4&scoped=true"
import script from "./duothemedialog.vue?vue&type=script&lang=js"
export * from "./duothemedialog.vue?vue&type=script&lang=js"
import style0 from "./duothemedialog.vue?vue&type=style&index=0&id=78b012b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b012b4",
  null
  
)

export default component.exports